export default {
  mediaSpendByChannel: 'Gasto em Mídia por Canal',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem'
}
